export default __webpack_public_path__ + "static/media/amiens2.7617a843.jpg";